import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


// type should be only 'prev' or 'next'
const NavigationButton = ({ type, navigationUrl, ...props }) => {
  const buttonTypes = ['prev', 'next'];

  if (!buttonTypes.includes(type)) {
    return null;
  }

  return (
    <a href={navigationUrl}
      rel={type}
      {...props}
      onClick={(e) => {
        e.preventDefault();
        if (!props.disabled) {
          props.onClick();
        };
      }}
      className={classNames(styles[type], 'jest-context-pagination')} />
  );
};

NavigationButton.propTypes = {
  type: PropTypes.string.isRequired,
};

export default NavigationButton;
